import {hookToAttributeSelector} from '@wix/panda-js-utils'
import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useAppActions} from '../../../../hooks/runtime'
import s from '../policy-checkbox.scss'
import {PolicyListProps} from './interfaces'

export const PolicyList = ({policies, onPolicyClick}: PolicyListProps) => {
  const {experiments} = useExperiments()
  const {openPolicyDetailsModal} = useAppActions()

  const relocatedPolicyModalEnabled = experiments.enabled(ExperimentNames.RelocatedPoliciesModal)

  return (
    <>
      {policies.map((policy, index) => {
        const last = policies.length - 1 === index
        return (
          <>
            <a
              data-hook={DH.POLICY}
              className={s.policy}
              href="#"
              onClick={event => {
                event.preventDefault()
                if (relocatedPolicyModalEnabled) {
                  openPolicyDetailsModal(policy)
                } else {
                  onPolicyClick(event, policy.id, `${hookToAttributeSelector(DH.POLICY)}[data-index="${index}"]`)
                }
              }}
              data-index={index}
              tabIndex={0}
            >
              {policy.name}
              {last ? '' : ','}
            </a>
            {last ? '' : ' '}
          </>
        )
      })}
    </>
  )
}
